import { useFormat } from 'vivat';
import useDelivery from '@/useDelivery';

const { shipmentStatusClassMap, translate } = useDelivery();

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    orderNumber: {
      name: 'เลขที่ใบส่งสินค้า (DO)',
      width: '10rem',
      class: 'text-center',
    },
    deliveryNote: {
      name: 'เลขที่ใบจัดรถ (DN)',
      width: '9rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: any, row: any) =>  val?.uniqueId ? val.uniqueId : '',
    },
    totalWeight: {
      name: 'น้ำหนัก (กก.)',
      width: '8rem',
      filter(val: string) {
        return parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      class: 'text-right',
    },
    deliveryFee: {
      name: 'ค่าจัดส่ง',
      width: '8rem',
      class: 'text-right',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    status: {
      name: 'สถานะ',
      width: '8rem',
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return shipmentStatusClassMap(val);
        },
      },
      filter(val: string, row: { item: { [key: string]: any }; index: number }) {
        return translate(val);
      },
    },
    completedDate: {
      name: 'วันที่ส่งสำเร็จ',
      width: '7rem',
      // eslint-disable-next-line
      filter: (val: string, row: any) => row.item?.completedDate ? useFormat.date(row.item.completedDate).displayShortThaiDate() : '',
      class: 'text-center',
    },
    senderCode: {
      name: 'รหัสผู้ฝากส่ง',
      width: '6rem',
      class: {
        text: 'text-left',
        cell: 'text-left',
      },
    },
    senderName: {
      name: 'ชื่อผู้ฝากส่ง',
      width: '16rem',
      // eslint-disable-next-line
      filter: (val: string) => val !== 'NA' ? val : '',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    customerCode: {
      name: 'รหัสผู้รับ',
      width: '6rem',
      class: {
        text: 'text-left',
        cell: 'text-left',
      },
    },
    customerName: {
      name: 'ชื่อผู้รับ',
      width: '16rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    path: {
      name: 'เส้นทางจัดส่ง',
      width: '6rem',
    },
  },
};
